import {connect} from 'react-redux'
import Stop from "../../Components/ProposedRoutes/ProposedRoute/RouteStops/Stop/Stop";

const mapStateToProps = (store) => {
    return {
        proposedDeliveryGroups: store.deliveryGroupsReducer.proposedDeliveryGroups
    };
};

const StopContainer = connect(mapStateToProps)(Stop);

export default StopContainer;